import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["content"]
const _hoisted_2 = ["content"]
const _hoisted_3 = { class: "flex flex-column flex-grow-1 align-items-center md:justify-content-center" }
const _hoisted_4 = { class: "card-form-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_7 = { class: "mb-s1" }
const _hoisted_8 = {
  key: 2,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_9 = {
  key: 3,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_10 = {
  key: 4,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_11 = {
  key: 5,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_12 = {
  key: 6,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_13 = {
  key: 7,
  class: "mt-s4 card-form-wrapper"
}
const _hoisted_14 = {
  key: 8,
  class: "card-form-append mt-s5"
}
const _hoisted_15 = { class: "panel-outlined" }
const _hoisted_16 = {
  key: 0,
  class: "mt-s3"
}

import BigNumber from 'bignumber.js';
import { computed, toRefs, ref, watch } from 'vue';
import SwapInfo from './components/SwapInfo.vue';
import Confirmation from './components/Confirmation.vue';
import InfoMessage from '@/components/InfoMessage.vue';
import { seo } from '@/composables/seo/useSeo';
import { Head } from '@vueuse/head';
import SwapForm from '@/views/pages/swap/components/SwapForm.vue';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useSwap } from '@/store/modules/swap/useSwap';
import { useSwapInfo } from '@/store/modules/swap/useSwapInfo';
import SwapRoute from '@/views/pages/swap/components/SwapRoute.vue';
import SwapSteps from '@/views/pages/swap/components/SwapSteps.vue';
import { SwapFormErrorName } from '@/store/modules/swap/models/swap-form-error';
import { useSwapSteps } from '@/store/modules/swap/useSwapSteps';
import { useSwapMilkomedaWSCBridge } from '@/store/modules/swap/useSwapMilkomedaWSCBridge';
import { useMilkomedaWSCBalanceADAIntoMilkomedaValidator } from '@/composables/milkomeda-wrapped-smartcontract/useMilkomedaWSCBalanceADAIntoMilkomedaValidator';
import { useAllSteps } from '@/composables/useAllSteps';
import { MIN_ADA_FOR_BRIDGE_FROM_MILKOMEDA_IN_ADA } from '@/helpers/milkomeda-wrapped-smartcontract/milkomeda-wsc-calculation';
import { useWallet } from '@/store/modules/wallet/useWallet';
import { SELECTED_NETWORK_NAME } from '@/helpers/networkParams.helper';
import ExternalLink from '@/components/ExternalLink.vue';
import { WSC_LEARN_MORE } from '@/constants/EXTERNAL_LINKS';
import { PRICE_IMPACT_MAX } from '@/store/modules/swap/constants/SWAP_PRICE_IMPACT_MAX';
import { isMultichainToken } from '@/helpers/token.helper';
import { usePortfoliosUpdater } from '@/composables/portfolios/usePortfoliosUpdater';
import { usePortfolios } from '@/composables/portfolios/usePortfolios';


export default /*#__PURE__*/_defineComponent({
  __name: 'Swap',
  setup(__props) {

const { t } = useI18n();
const { state } = useStore();
const { swapForm, doSwap } = useSwap();
const { swapInfo } = useSwapInfo();
const { milkomedaWSCBridgeState } = useSwapMilkomedaWSCBridge();
const { swapSteps, prepareSteps, runSteps } = useSwapSteps();
const { walletState } = useWallet();
const { milkomedaWSCBalanceADAIntoMilkomedaValidatorState, validateADABalanceForMilkomeda } =
  useMilkomedaWSCBalanceADAIntoMilkomedaValidator();
const { isPortfoliosStatisticLoaded } = usePortfolios();
const { isEnabledPortfoliosUpdater, enablePortfoliosUpdater } = usePortfoliosUpdater();

const isConfirmationDialog = ref(false);
const isSwapSteps = ref(swapSteps.isShown);
const swapInProgress = ref(false);

const allStepsState = useAllSteps();
const isSomeInProgress = computed(() => !swapSteps.inProgress && allStepsState.isInProgress.state);
// SWAP STEPS
const onShowSteps = () => {
  isSwapSteps.value = true;
  swapSteps.isShown = true;
};
const onCloseSteps = () => {
  isSwapSteps.value = false;
  swapSteps.isShown = false;
  swapSteps.inProgress = false;
};
// SWAP CONFIRMATION
const onCloseConfirmation = () => {
  isConfirmationDialog.value = false;
};
const onShowConfirmation = () => {
  isConfirmationDialog.value = true;
};
const onConfirmSwap = async () => {
  onCloseConfirmation();

  if (ENABLE_FAKE_CARDANO_NETWORK) {
    prepareSteps();
    onShowSteps();
    await runSteps();
    return;
  }

  await doSwap();
};
const onCancelSwap = () => {
  onCloseConfirmation();
  console.log('Cancel swap');
};

const getError = (errorType: SwapFormErrorName) => {
  return Object.values(swapForm.errors).find(type => type === errorType);
};
const isSameTokensError = computed(() => getError('sameTokens'));
const isNoRouteError = computed(() => getError('noRoute'));

const isInsufficiencyBalanceIntoCardano = computed(() =>
  ENABLE_FAKE_CARDANO_NETWORK
    ? !milkomedaWSCBridgeState.isValidCardanoBalance && milkomedaWSCBridgeState.minADABalance
    : false,
);
const isInsufficiencyBalanceIntoMilkomedaWhenUnwrapADA = computed(() =>
  ENABLE_FAKE_CARDANO_NETWORK &&
  swapForm.input?.token?.isETHToken() &&
  swapForm.isSwapSameTokensFromMilkomedaToCardano &&
  !allStepsState.isInProgress.state &&
  !swapSteps.isShown
    ? !validateADABalanceForMilkomeda()
    : false,
);
const isInsufficiencyBalance = computed(
  () =>
    isInsufficiencyBalanceIntoCardano.value ||
    isInsufficiencyBalanceIntoMilkomedaWhenUnwrapADA.value,
);
const minADABalance = computed(() => {
  if (isInsufficiencyBalanceIntoCardano.value) {
    return milkomedaWSCBridgeState.minADABalance ?? '0';
  }

  if (isInsufficiencyBalanceIntoMilkomedaWhenUnwrapADA.value) {
    return milkomedaWSCBalanceADAIntoMilkomedaValidatorState.minADABalance;
  }

  return '0';
});
const moreADARequiredMessage = computed(() =>
  t('swap.infoMessage.moreTokenRequired', {
    amount: BigNumber(minADABalance.value).toFixed(2),
    token: 'ADA',
  }),
);
const isLessMinADAAmountForBridge = computed(() => getError('lessMinAmountForUnwrap'));
const lessMinADAAmountMessage = computed(() =>
  t('swap.infoMessage.lessMinAmountForUnwrap', {
    minAmount: MIN_ADA_FOR_BRIDGE_FROM_MILKOMEDA_IN_ADA,
    tokenSymbol: 'ADA',
  }),
);
const isShowSwapInfo = computed(() => swapForm.isShowSwapInfo);
const isShowRoute = computed(() => swapForm.bestTrade && swapInfo.route?.path?.length);
const isSwapSameTokensFromMilkomedaToCardano = computed(
  () => swapForm.isSwapSameTokensFromMilkomedaToCardano,
);
const isPriceImpactTooBig = computed(() => Number(swapInfo.priceImpact) > PRICE_IMPACT_MAX);

const walletName = computed(() =>
  walletState.isInjected ? walletState.wallets[SELECTED_NETWORK_NAME].connector.name : t('your'),
);
const isMultichainTokenTo = computed(() => {
  return swapForm.output.token ? isMultichainToken(swapForm.output.token.symbol as string) : false;
});
watch(toRefs(swapForm).bestTradeRequestInProgress, value => {
  if (value) swapForm.isShowSwapInfo = value;
});

watch(
  isPortfoliosStatisticLoaded,
  () => {
    if (!isEnabledPortfoliosUpdater.value) {
      enablePortfoliosUpdater();
    }
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, _toDisplayString(_unref(seo).SEO_SWAP.TITLE), 1),
        _createElementVNode("meta", {
          property: "description",
          name: "description",
          content: _unref(seo).SEO_SWAP.DESCRIPTION
        }, null, 8, _hoisted_1),
        _createElementVNode("meta", {
          property: "keywords",
          name: "keywords",
          content: _unref(seo).SEO_SWAP.KEYWORDS
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (isSwapSteps.value)
          ? (_openBlock(), _createBlock(SwapSteps, {
              key: 0,
              onOnClose: onCloseSteps
            }))
          : (_openBlock(), _createBlock(SwapForm, {
              key: 1,
              onOnSwap: onShowConfirmation,
              "swap-in-progress": swapInProgress.value
            }, null, 8, ["swap-in-progress"]))
      ]),
      (_unref(isMultichainTokenTo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(InfoMessage, {
              type: "warning",
              icon: "error",
              "as-panel": "",
              message: _unref(t)('swap.infoMessage.multichainToken')
            }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isSwapSameTokensFromMilkomedaToCardano))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(InfoMessage, {
              type: "info",
              icon: "error",
              "as-panel": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('swap.infoMessage.sameTokensFromMilkomedaToCardano', { walletName: _unref(walletName) })), 1),
                _createVNode(ExternalLink, {
                  label: _unref(t)('readMore'),
                  url: _unref(WSC_LEARN_MORE),
                  color: "info"
                }, null, 8, ["label", "url"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isSameTokensError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(InfoMessage, {
              type: "danger",
              message: _unref(t)('swap.infoMessage.selectDifferentTokens'),
              "as-panel": ""
            }, null, 8, ["message"])
          ]))
        : (_unref(isNoRouteError))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(InfoMessage, {
                type: "danger",
                message: _ctx.$t('swap.infoMessage.noRouteOrLiquidity'),
                "as-panel": ""
              }, null, 8, ["message"])
            ]))
          : _createCommentVNode("", true),
      (_unref(isInsufficiencyBalance) && _unref(isShowSwapInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(InfoMessage, {
              type: "danger",
              message: _unref(moreADARequiredMessage),
              "as-panel": ""
            }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isLessMinADAAmountForBridge))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(InfoMessage, {
              type: "danger",
              message: _unref(lessMinADAAmountMessage),
              "as-panel": ""
            }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isSomeInProgress))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(InfoMessage, {
              type: "warning",
              message: _unref(t)('wrappedContract.steps.infoMessage.someInProgress'),
              "as-panel": ""
            }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isPriceImpactTooBig))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(InfoMessage, {
              type: "danger",
              message: _unref(t)('swap.infoMessage.priceImpactTooBig'),
              "as-panel": ""
            }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
      (_unref(isShowSwapInfo))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(SwapInfo)
            ]),
            (_unref(isShowRoute))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(SwapRoute)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        visible: isConfirmationDialog.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isConfirmationDialog).value = $event)),
        header: 
        _unref(t)('swap.confirmDialog.header', {
          input: _unref(swapForm).input.token?.symbol,
          output: _unref(swapForm).output.token?.symbol,
        })
      ,
        modal: true,
        dismissableMask: "",
        "content-class": _unref(state).layout.isMobile ? 'dialog-content-scrollable -mr-s3 pr-s2' : '',
        style: { width: '30rem' }
      }, {
        default: _withCtx(() => [
          _createVNode(Confirmation, {
            cancel: onCancelSwap,
            confirm: onConfirmSwap
          })
        ]),
        _: 1
      }, 8, ["visible", "header", "content-class"])
    ])
  ], 64))
}
}

})